import { createApp } from 'vue'
import LottieAnimation from "lottie-web-vue";
import App from './App.vue'
import store from './store'

createApp(App)
    .use(store)
    .use(LottieAnimation)
    .mount('#app')
